import { render, staticRenderFns } from "./MoonPayBuyComponent.vue?vue&type=template&id=0c6a42d3&scoped=true&"
import script from "./MoonPayBuyComponent.vue?vue&type=script&lang=js&"
export * from "./MoonPayBuyComponent.vue?vue&type=script&lang=js&"
import style0 from "./MoonPayBuyComponent.vue?vue&type=style&index=0&id=0c6a42d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a42d3",
  null
  
)

export default component.exports